import { useState } from "react";
import { Slider } from "./ui/slider";
import { useTranslation } from "@/hooks/useTranslation";

export default function MaleRewardSlider() {
  const [sliderIndex, setSliderIndex] = useState(0);
  const t = useTranslation();

  const values = [1, 10, 20, 30];
  const actualValue = values[sliderIndex];

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-row justify-between items-center">
        <span>{t.REFERRAL_PAGE.LABELS.REFERRALS}</span>
        <span className="text-lg font-bold">{actualValue}</span>
      </div>
      <Slider
        value={[sliderIndex]}
        onValueChange={(v) => setSliderIndex(v[0])}
        max={3}
        min={0}
        step={1}
        className="flex-grow hover:cursor-pointer"
      />
      <div className="flex flex-row justify-between w-full items-center">
        <span>{t.REFERRAL_PAGE.LABELS.EARNINGS}</span>
        <span className="text-lg font-bold">${actualValue * 50}</span>
      </div>
    </div>
  );
}
